<div class="container">
  <div *ngIf="currentUser">
    <h3>Welcome, {{ currentUser.MemberName }}</h3>
  </div>
  <p>
    This pension calculator was designed exclusively for members of the Nuclear
    Waste Management Organization (NWMO) Pension Plan. Your Nuclear Waste
    Management Organization (NWMO) pension represents a key component of your
    future retirement income, along with government pensions and your personal
    savings. This pension calculator tool allows you to project your Nuclear
    Waste Management Organization (NWMO) pension to a future retirement date,
    giving you a better sense of your future income as you plan for retirement.
  </p>
  <br />
  <strong>
    <p>
      To learn more about your Nuclear Waste Management Organization (NWMO)
      Pension Plan or view your Annual Statement, contact
      <a href="mailto:NWMOpensions@eckler.ca">NWMOpensions@eckler.ca</a> or
      visit the
      <a href="http://nwmopensions.docucentre.ca/" target="_blank"
        >NWMO Pension Plan hub</a
      >.
    </p>
  </strong>
</div>
<br />
<br />
<div>
  <strong class="important">Disclaimer</strong>
  <br />
  <p>
    This is a retirement planning tool only. Although every effort has been made
    to provide pension estimates that are accurate, these estimates are not a
    statement of fact or promise of a future pension. All estimates are based on
    the current provisions of the Nuclear Waste Management Organization (NWMO)
    Pension Plan and your personal information as entered in the tool. In some
    cases, errors or limitations in the data inputs may produce inaccurate
    results. The Plan Administrator is not responsible for any decisions you
    make using this pension calculator or any liabilities that may arise from
    those decisions. If you have questions, please contact <a href="mailto:NWMOpensions@eckler.ca">NWMOpensions@eckler.ca</a>.
  </p>
</div>
<br />
<br />
<div class="checkbox-container">
  <mat-checkbox [(ngModel)]="agreedToTerms" [checked]="agreedToTerms">
  </mat-checkbox>
  <p>
    I confirm that I have read and agree with the
    <strong class="terms__text"
      ><a (click)="viewTermsAndConditions()">Terms & Conditions</a></strong
    >
    for this Pension Calculator Tool. I understand that it is for illustration
    and information purposes only, and that actual outcomes, being the funds
    available at my retirement, will be determined by future economic conditions
    and other unknown variables. I will not hold Nuclear Waste Management
    Organization (NWMO) liable for any decisions I make based on the information
    provided by this tool. I understand that I am encouraged to use other
    financial planning tools and/or get the advice of a financial advisor or
    other qualified advisor.
  </p>
</div>

<div class="button-container">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!agreedToTerms"
    (click)="getStartedClick()"
  >
    GET STARTED
  </button>
</div>
